export default function Subheading({ title, subTitle, isFirst }) {
    return (
        <div className={`bg-gray-100 mb-1 -m-10 p-4 font-semibold text-lg border ${isFirst ? '' : 'mt-10'}`}>
            <span>{title} </span>
            <span className="font-thin mx-3 text-xs">
                {subTitle}
            </span>
        </div>
    )
}